<template>
  <div class="list-group-item ">
    <div class="card">
      <div class="card-body">
        <div class="row align-items-center" @click="emit('onSelect')">
          <div class="col fw-bold text-dark">
            <i class="fas fa-credit-card me-2"></i>
            <CardInfoContainer :info="card" />
          </div>
          <div class="col-auto">
            <i v-if="selected" class="fas fa-check-circle text-primary"></i>
            <i v-else class="far fa-circle text-muted"></i>
          </div>
        </div>
        <div class="row align-items-center mt-2">
          <div class="col">
            <button class="btn btn-link text-muted ps-0 pb-0" @click="emit('onRemove')">
              <i class="fas fa-trash-alt me-1"></i> Remover
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ICardInfo } from '@/interfaces';
import CardInfoContainer from './CardInfoContainer.vue';


defineProps<{
  card: ICardInfo,
  selected: boolean
}>()

const emit = defineEmits<{
  onRemove: [],
  onSelect: [],
}>()

</script>